import { z } from 'zod';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const createFieldNames = <T extends z.ZodObject<any>>(schema: T) => {
	const keys = Object.keys(schema.shape) as Array<keyof z.infer<T>>;
	return keys.reduce(
		(acc, key) => {
			acc[key] = key;
			return acc;
		},
		{} as Record<keyof z.infer<T>, keyof z.infer<T>>
	);
};
